module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAlCAYAAAAuqZsAAAAACXBIWXMAAAsSAAALEgHS3X78AAAAjElEQVRYCe3YMQ5EABSE4SEkzqLiEq5lj7KNM2g5h0pFolHQWEEIko1qKq+Yv53mq8cBgCzxP7DV1zs5aRgHJmR1NWEcluKCIYxswLpm3mFwH4uRBGMTjE0wNsHYBGMTjE0wNsHYBGMTjE0wNsHYBGMTjE0wNrOw+7jr2vkxvtFvWv9gRZkPJmBHQL8BCJUZlywLHbYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-yellow-2.png
// module id = 255
// module chunks = 0